import {
  UTM_KEYS,
  encodeUtmValue,
  extractUtmParams,
} from "@greenflagdate/shared";

/**
 * Persist the UTM params from a landing URL and mirror them onto the shared
 * request headers so server-side events carry attribution.
 *
 * A UTM-tagged visit is treated as an all-or-nothing touch: when the URL
 * carries any utm_* param, the previous campaign's params are cleared first, so
 * a later partial touch (e.g. a link with only utm_source) can't merge with
 * stale keys left over from an earlier campaign. Values are percent-encoded
 * before they go onto storage/headers so non-Latin1 campaign strings don't
 * break fetch; the API decodes them on ingestion.
 */
export function syncUtmFromUrl(
  search: string,
  headers: Record<string, string>,
): void {
  const incoming = extractUtmParams(search);
  if (!Object.keys(incoming).length) {
    return;
  }
  for (const key of UTM_KEYS) {
    sessionStorage.removeItem(key);
    delete headers[key];
  }
  for (const [key, value] of Object.entries(incoming)) {
    const encoded = encodeUtmValue(value);
    sessionStorage.setItem(key, encoded);
    headers[key] = encoded;
  }
}

/**
 * Seed request headers from any UTM values captured earlier this session.
 * Runs at module load so the first API calls of a returning-tab visit still
 * carry attribution.
 */
export function hydrateUtmHeaders(headers: Record<string, string>): void {
  for (const key of UTM_KEYS) {
    const value = sessionStorage.getItem(key);
    if (value) {
      headers[key] = value;
    }
  }
}
